import React from 'react';
import { SearchX, Inbox, X } from 'lucide-react';

interface EmptyStateProps {
  type?: 'empty' | 'no-search';
  icon?: React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  searchQuery?: string;
  actionButton?: React.ReactNode;
  onClearSearch?: () => void;
}

export function EmptyState({
  type = 'empty',
  icon: Icon,
  title,
  description,
  searchQuery,
  actionButton,
  onClearSearch,
}: EmptyStateProps) {
  const DefaultIcon = type === 'no-search' ? SearchX : Inbox;
  const DisplayIcon = Icon || DefaultIcon;

  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center rounded-2xl border border-dashed border-border bg-surface-secondary/30">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-sky/15 text-brand-sky mb-4 shadow-xs">
        <DisplayIcon className="h-7 w-7 text-brand-deep dark:text-brand-sky" />
      </div>

      <h3 className="text-base font-bold text-text-primary mb-1">{title}</h3>

      {description && (
        <p className="text-xs text-text-secondary max-w-sm mb-4 leading-relaxed">
          {description}
        </p>
      )}

      {searchQuery && (
        <p className="text-xs text-text-tertiary mb-4 font-mono">
          Coincidencias no encontradas para: <span className="font-bold text-text-secondary font-sans">&quot;{searchQuery}&quot;</span>
        </p>
      )}

      {onClearSearch && (
        <button
          type="button"
          onClick={onClearSearch}
          className="inline-flex items-center gap-1.5 px-4 py-2 text-xs font-bold text-brand-orange bg-brand-orange/10 hover:bg-brand-orange/20 rounded-xl transition-all cursor-pointer shadow-xs"
        >
          <X className="h-3.5 w-3.5" />
          <span>Limpiar búsqueda</span>
        </button>
      )}

      {actionButton && <div className="mt-1">{actionButton}</div>}
    </div>
  );
}
